export const BUSINESS_ROLES = Object.freeze({
  HEADQUARTERS: "HEADQUARTERS",
  BRANCH: "BRANCH",
  NONE: "NONE",
});

// Invalid CNPJs cannot be classified, so they get no badge at all.
export const getBusinessRole = (business) => {
  if (!business?.cnpjValid) return BUSINESS_ROLES.NONE;
  return business.headquarters ? BUSINESS_ROLES.HEADQUARTERS : BUSINESS_ROLES.BRANCH;
};

export const getBranchCount = (business) => {
  const groupSize = Number(business?.groupSize || 0);
  return Math.max(0, groupSize - (business?.headquartersInGroup ? 1 : 0));
};

const getClientKey = (client) => `${client.partyId}-${client.matterId}`;

// The backend already orders items (groups in order, headquarters first, then
// branches by establishment) and never splits a group across pages, so
// grouping only needs to preserve the arrival order.
export const groupBusinessClients = (clients = []) => {
  const groups = [];
  const groupsByKey = new Map();

  clients.forEach((client) => {
    const groupKey = client?.business?.groupKey || `client:${getClientKey(client)}`;
    let group = groupsByKey.get(groupKey);
    if (!group) {
      group = { groupKey, rows: [] };
      groupsByKey.set(groupKey, group);
      groups.push(group);
    }
    group.rows.push(client);
  });

  return groups.map(({ groupKey, rows }) => {
    const leadIndex = Math.max(0, rows.findIndex((row) => row.business?.headquarters));
    const lead = rows[leadIndex];
    const members = rows.filter((_, index) => index !== leadIndex);
    const business = lead.business || {};
    const groupSize = Math.max(Number(business.groupSize || 0), rows.length);

    return {
      groupKey,
      lead,
      members,
      groupSize,
      headquartersInGroup: Boolean(business.headquartersInGroup),
      branchCount: getBranchCount({ ...business, groupSize }),
      expandable: groupSize > 1 && members.length > 0,
    };
  });
};
